import React from 'react';
import AlbumReviewMenu from '../album/AlbumReviewMenu';
import { Box, Typography } from '@mui/material';
import { useUserStore } from '../../../../stores/userStore';
import EditDeleteMenuButton from '../../../../components/button/EditDeleteMenuButton';
import theme from '../../../../theme';
import { useNavigateWithScrollMemory } from '../../../../hooks/useNavigateWithScrollMemory';
import UserWithProfile from '../../../../components/common/UserWithProfile';
import Rating from '../../../../components/common/Rating';

const MyReviewDisplay = ({ myReview, onEdit, onDelete, onRequestDelete }) => {
  const user = useUserStore((state) => state.user);
  const navigateWithScrollMemory = useNavigateWithScrollMemory();

  if (!myReview) return null;

  return (
    <Box sx={{ px: { xs: 2, lg: 2.5 }, py: 2.5, bgcolor: theme.palette.grey.bg }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <UserWithProfile
          username={user.nickname}
          profileImageUrl={user.profileImageUrl}
          userNickname={user.nickname}
          grade={user.grade}
          onClick={() => navigateWithScrollMemory(`/users/${encodeURIComponent(user.nickname)}`)}
          spacing={1}
        />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-end' }}>
            <Rating value={myReview.rating} readOnly />
          </Box>
          {onRequestDelete ? (
            <AlbumReviewMenu onEdit={onEdit} onRequestDelete={onRequestDelete} />
          ) : (
            <EditDeleteMenuButton variant="small" onEdit={onEdit} onDelete={onDelete} />
          )}
        </Box>
      </Box>
      <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-start', mb: 2 }}>
        <Rating value={myReview.rating} readOnly />
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography
          fontSize={14}
          color={theme.palette.black[6]}
          sx={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            maxWidth: '100%',
            lineHeight: 1.5,
          }}
        >
          {myReview.content}
        </Typography>
      </Box>
      <Typography fontSize={14} color={theme.palette.black[1]}>
        {myReview.updatedAt}
      </Typography>
    </Box>
  );
};

export default MyReviewDisplay;
